export const ORDERER_BADGE_CONFIG = {
  new:         { label: 'Ny bestiller',       icon: '⭐', color: '#888' },
  active:      { label: 'Aktiv',              icon: '🔵', color: '#2980b9' },
  experienced: { label: 'Erfaren',            icon: '🌟', color: '#27ae60' },
  premium:     { label: 'Storkunde',          icon: '🏆', color: '#f39c12' },
  verified:    { label: 'Verifisert bedrift', icon: '✅', color: '#27ae60' },
};

export function computeOrdererBadge({ orderCount = 0, tippiVerified = false }) {
  if (tippiVerified === true) return 'verified';
  if (orderCount >= 25) return 'premium';
  if (orderCount >= 10) return 'experienced';
  if (orderCount >= 3)  return 'active';
  return 'new';
}
